const SELECTOR_INPUT_DESTINO = "[data-input-configuracion-id]";

const coincideConDestino = (elemento, destino) => {
  const destinoNormalizado = String(destino ?? "").trim();
  if (!destinoNormalizado) return false;

  return [
    elemento.dataset.inputConfiguracionId,
    elemento.dataset.inputClaveEnvio,
    elemento.dataset.inputCampoAlias,
  ].some((identificador) => identificador === destinoNormalizado);
};

const buscarInputDestino = (origen, destino) => {
  if (typeof document === "undefined") return null;

  const scope = origen?.closest?.(".tarjeta_grid_item, .abm");
  const scopes = scope ? [scope, document] : [document];

  for (const currentScope of scopes) {
    const encontrado = Array.from(
      currentScope.querySelectorAll(SELECTOR_INPUT_DESTINO),
    ).find((elemento) => coincideConDestino(elemento, destino));

    if (encontrado) return encontrado;
  }

  return null;
};

const setNativeInputValue = (input, value) => {
  const view = input.ownerDocument?.defaultView ?? window;
  const prototype =
    input.tagName === "TEXTAREA"
      ? view.HTMLTextAreaElement?.prototype
      : view.HTMLInputElement?.prototype;
  const valueSetter = Object.getOwnPropertyDescriptor(prototype, "value")?.set;

  if (valueSetter) {
    valueSetter.call(input, value);
  } else {
    input.value = value;
  }
};

export const entregarValorAInputDestino = ({ origen, destino, valor }) => {
  const input = buscarInputDestino(origen, destino);
  if (!input || input.disabled || input.readOnly) return false;

  setNativeInputValue(input, valor);

  const EventConstructor = input.ownerDocument?.defaultView?.Event ?? Event;
  input.dispatchEvent(new EventConstructor("input", { bubbles: true }));

  return true;
};
